import React, { useEffect, useMemo, useState } from "react";
import styles from "./Account.module.scss";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Table from "../../components/Table";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";

export default function Account({
  theme,
  eurToUsd,
  accounts,
  setSnackType,
  setSnackMessage,
  handleClick,
  getSymbolByAccount
}) {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [deposit, setDeposit] = useState(0);
  const [withdrawal, setWithdrawal] = useState(0);
  const [account, setAccount] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_test_url}/api/transactions/crm/${id}`, {
        headers: {
          Authorization: "Bearer " + secureLocalStorage.getItem("token"),
        },
      })
      .then((result) => {
        const deposits = result.data?.deposits || [];
        setDeposit(result.data?.deposits?.reduce((a, b) => a + b?.Sum, 0));
        const withdrawals = result.data?.withdrawals || [];
        setWithdrawal(
          result.data?.withdrawals?.reduce((a, b) => a + b?.Sum, 0)
        );
        const allTransactions = [...deposits, ...withdrawals];

        // Сортировка по дате (новые сначала)
        allTransactions.sort((a, b) => new Date(b.Date) - new Date(a.Date));

        setTransactions(allTransactions);
      })
      .catch((e) => console.log(e));
    setAccount(accounts?.find((val) => val?.Id == id));
  }, [id]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "Date",
        header: t("Date"),
        size: 160,
        grow: 1,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Date")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>{moment(row.original.Date).format("YYYY-MM-DD HH:mm")}</span>
          );
        },
      },
      {
        accessorKey: "Type",
        header: t("Type"),
        size: 70,
        grow: 1,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Type")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={
                row.original.Type === "Deposit"
                  ? {
                      color: "#00B4A0",
                      borderRadius: "9999px",
                      padding: "0.4vh 0.8vh",
                      width: "max-content",
                      background: "rgba(0, 180, 160, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "0.8vh",
                    }
                  : {
                      color: "#E9770E",
                      borderRadius: "9999px",
                      padding: "0.4vh 0.8vh",
                      width: "max-content",
                      background: "rgba(233, 119, 14, 0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "0.8vh",
                    }
              }
            >
              {row.original.Type === "Deposit" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.7vh"}
                  height={"1.6vh"}
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.3812 13.3335V9.3335M13.3812 9.3335L14.7145 10.6668M13.3812 9.3335L12.0479 10.6668"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.3809 7.99984C15.3809 5.48568 15.3809 4.2286 14.5999 3.44755C13.8188 2.6665 12.5618 2.6665 10.0476 2.6665H7.38094C4.86678 2.6665 3.6097 2.6665 2.82866 3.44755C2.04761 4.2286 2.04761 5.48568 2.04761 7.99984C2.04761 10.514 2.04761 11.7711 2.82866 12.5521C3.6097 13.3332 4.86678 13.3332 7.38094 13.3332H10.0476"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.38102 10.6665H4.71436"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.38119 10.6665H9.04785"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.04761 6.6665L15.3809 6.6665"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.7vh"}
                  height={"1.6vh"}
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.3812 9.3335V13.3335M13.3812 13.3335L14.7145 12.0002M13.3812 13.3335L12.0479 12.0002"
                    stroke="#E9770E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.3809 7.99984C15.3809 5.48568 15.3809 4.2286 14.5999 3.44755C13.8188 2.6665 12.5618 2.6665 10.0476 2.6665H7.38094C4.86678 2.6665 3.6097 2.6665 2.82866 3.44755C2.04761 4.2286 2.04761 5.48568 2.04761 7.99984C2.04761 10.514 2.04761 11.7711 2.82866 12.5521C3.6097 13.3332 4.86678 13.3332 7.38094 13.3332H10.0476"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.38102 10.6665H4.71436"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.38119 10.6665H9.04785"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.04761 6.6665L15.3809 6.6665"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                </svg>
              )}
              {row.original.Type}
            </span>
          );
        },
      },
      {
        accessorKey: "Sum",
        header: t("Amount"),
        size: 110,
        grow: 1,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Amount")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {getSymbolByAccount()}{" "}
              {parseFloat(
                row.original.Sum *
                  (account?.AccountCurrency === "EUR"
                    ? eurToUsd
                    : 1)
              ).toFixed(2)}
            </span>
          );
        },
      },
      {
        accessorKey: "Status",
        header: t("Status"),
        size: 100,
        grow: 1,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Status")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={{
                color: "#52A5E5",
                padding: "4px 8px",
                borderRadius: "9999px",
                fontSize: "1.2vh",
                background: "rgba(82, 165, 229, 0.08)",
              }}
            >
              Completed
            </span>
          );
        },
      },
    ],
    [i18n.language, transactions]
  );

  const calculateCurrentProfit = (account, transactions) => {
    const totalTransactions = transactions.reduce((sum, transaction) => {
      if (transaction?.Type === "Deposit") {
        return sum + (transaction?.Sum || 0);
      } else if (transaction?.Type === "Withdrawal") {
        return sum - (transaction?.Sum || 0);
      }
      return sum;
    }, 0);

    const currentProfit = account?.AccountBalance - totalTransactions;
    const profitPercentage = (
      (currentProfit / totalTransactions) *
      100
    ).toFixed(1);

    return {
      currentProfit: currentProfit.toFixed(1),
      profitPercentage,
    };
  };

  const { currentProfit, profitPercentage } = calculateCurrentProfit(
    account,
    transactions
  );
  return (
    <div className={styles.account}>
      <div className={styles.account_title}>
        <div className={styles.left_side}>
          <Link to="/cabinet/accounts">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"1.6vh"}
              height={"1.6vh"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <ellipse
                cx="7.99992"
                cy="3.99967"
                rx="2.66667"
                ry="2.66667"
                fill="#51525C"
              />
              <ellipse
                cx="7.99992"
                cy="11.3337"
                rx="4.66667"
                ry="2.66667"
                fill="#51525C"
              />
            </svg>
            {t("Accounts")}
          </Link>
          <div>/</div>
          <div>{account?.AccountTitle}</div>
        </div>
        <div className={styles.right_side}></div>
      </div>
      <div className={styles.account_body}>
        <div className={styles.account_info_block}>
          <div className={styles.account_info}>
            <div className={styles.info_title}>
              <div className={styles.account_name}>
                <p>{account?.AccountTitle}</p>
                {/* <span>{account?.AccountTitle}</span> */}
              </div>
              <div className={styles.id}>
                ID:
                <span>{id}</span>
              </div>
            </div>
            <div className={styles.info_block}>
              <span className={styles.chart}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="249"
                  viewBox="0 0 726 249"
                  fill="none"
                >
                  <path
                    d="M0 206.354L5.02058 196.069C5.38343 195.325 6.16647 194.882 6.99058 194.954L9.64122 195.183C10.583 195.265 11.4533 194.676 11.7278 193.771L15.1908 182.357C15.7433 180.536 18.2869 180.443 18.9709 182.219L21.8742 189.756C22.239 190.703 23.2548 191.227 24.2376 190.975L27.9077 190.033C28.0599 189.994 28.2162 189.973 28.3732 189.971L32.5094 189.905C33.2802 189.893 33.9892 190.325 34.3321 191.015L37.3073 197.005C38.0911 198.583 40.3844 198.45 40.9805 196.792L45.0278 185.535L49.3969 167.91C49.8379 166.131 52.2403 165.832 53.1028 167.45L56.2734 173.394L60.4621 182.684C61.0997 184.099 63.0345 184.28 63.9239 183.009L66.3287 179.573C66.9831 178.638 68.2861 178.439 69.1896 179.137L70.8176 180.394C71.9399 181.26 73.5825 180.716 73.9656 179.351L78.3728 163.642C78.6174 162.77 79.4169 162.171 80.3221 162.182L82.9122 162.213C83.8055 162.223 84.5834 162.825 84.8182 163.687L88.1578 175.946C88.6901 177.9 91.4561 177.917 92.011 175.969L93.5289 170.641C94.0966 168.648 96.9478 168.728 97.4034 170.749L100.189 183.108C100.588 184.877 102.946 185.245 103.864 183.681L106.779 178.721C106.883 178.545 106.959 178.354 107.004 178.154L112.431 154.484C112.514 154.122 112.697 153.789 112.959 153.525L118.01 148.42C118.124 148.305 118.223 148.177 118.306 148.039L122.386 141.208C123.088 140.033 124.736 139.894 125.624 140.935L126.428 141.878C127.567 143.212 129.749 142.54 129.938 140.796L134.225 101.276C134.449 99.2158 137.273 98.8138 138.063 100.73L140.695 107.12L144.01 116.078C144.699 117.94 147.387 117.769 147.834 115.834L151.661 99.2763C151.838 98.5113 152.446 97.9205 153.216 97.7659L156.395 97.1272C157.127 96.9802 157.88 97.2529 158.347 97.8346L163.209 103.879L168.672 111.988C168.778 112.145 168.861 112.316 168.919 112.496L172.572 123.911C173.165 125.761 175.781 125.765 176.38 123.917L180.026 112.661C180.068 112.533 180.122 112.41 180.188 112.293L184.646 104.408C185.224 103.385 186.556 103.079 187.523 103.747L190.807 106.015C191.157 106.257 191.421 106.604 191.56 107.006L196.98 122.634L202.602 134.176L208.237 146.183L211.878 156.101C212.531 157.881 215.063 157.837 215.655 156.036L219.494 144.363L225.116 127.717L230.674 109.882C230.717 109.743 230.745 109.599 230.758 109.453L236.336 42.4032C236.361 42.1081 236.45 41.8221 236.599 41.5659L239.771 36.0944C240.635 34.6037 242.854 34.8306 243.399 36.4654L245.575 42.9998C246.198 44.8685 248.862 44.8068 249.398 42.9112L250.414 39.3125C251.013 37.1909 254.101 37.4574 254.328 39.6503L258.829 83.1647C258.867 83.5319 259.006 83.8813 259.23 84.1745L264.319 90.8236C264.446 90.9887 264.546 91.1725 264.615 91.3684L269.862 106.106C270.043 106.612 270.419 107.025 270.908 107.251L273.467 108.433C274.64 108.974 276.012 108.278 276.266 107.011L281.357 81.6927C281.379 81.5837 281.41 81.4767 281.45 81.3728L286.693 67.6569C286.903 67.1079 287.344 66.679 287.898 66.4842L291.32 65.2821C292.116 65.0024 293.002 65.2524 293.534 65.9068L297.9 71.2732C298.149 71.5782 298.481 71.8033 298.856 71.9203L303.571 73.3904C303.791 73.4591 303.998 73.5654 304.182 73.7046L307.726 76.3852C308.687 77.1122 310.068 76.8303 310.668 75.7846L314.786 68.5988C315.028 68.1777 315.414 67.8587 315.873 67.7013L319.982 66.2931C320.501 66.1152 320.924 65.7319 321.152 65.2329L323.81 59.4212C324.62 57.6491 327.228 57.964 327.593 59.8779L331.998 82.9541C332.034 83.1423 332.096 83.3244 332.184 83.4948L337.241 93.3151C337.515 93.8485 338.015 94.2304 338.602 94.3555L341.597 94.9939C342.572 95.2018 343.551 94.6593 343.893 93.7222L348.932 79.8864L354.463 65.6496C354.524 65.494 354.604 65.3465 354.701 65.2107L360.189 57.536L363.751 50.8983C364.56 49.3916 366.764 49.5289 367.379 51.1243L368.91 55.0922C369.635 56.9721 372.371 56.7209 372.742 54.7404L377.068 31.6342L382.063 5.72047C382.351 4.22772 384.133 3.58904 385.303 4.55923L386.503 5.55356C387.456 6.34363 388.891 6.08681 389.51 5.01517L391.401 1.7461C392.311 0.173326 394.677 0.530413 395.082 2.3016L398.951 19.2178C399.259 20.5647 400.807 21.201 401.973 20.4599L404.542 18.8276C404.968 18.5566 405.276 18.1343 405.404 17.6455L409.14 3.35478C409.643 1.43092 412.34 1.3402 412.971 3.22592L415.858 11.8525C416.197 12.863 417.268 13.4309 418.294 13.1439L421.954 12.12C422.049 12.0936 422.141 12.0603 422.23 12.0204L426.223 10.2394C427.093 9.85141 428.116 10.1307 428.668 10.907L432.746 16.6427C433.126 17.1771 433.744 17.4913 434.4 17.4836L437.821 17.4431C438.536 17.4346 439.201 17.808 439.565 18.4227L444.335 26.4643C444.515 26.7686 444.773 27.0195 445.082 27.1916L449.41 29.6006C449.931 29.8905 450.296 30.3978 450.404 30.984L455.856 60.4213L460.794 89.1934C461.072 90.8138 463.108 91.3824 464.186 90.1406V90.1406C465.3 88.8558 467.411 89.5163 467.594 91.2073L472.073 132.516C472.283 134.451 474.852 134.977 475.806 133.28L478.224 128.974C478.321 128.803 478.391 128.618 478.434 128.426L483.776 104.265C483.919 103.621 484.37 103.088 484.982 102.842L487.204 101.947C488.426 101.455 489.781 102.257 489.937 103.565L495.152 147.117C495.221 147.694 495.537 148.212 496.019 148.537L500.502 151.563C500.753 151.733 501.039 151.843 501.339 151.886L504.988 152.404C505.884 152.531 506.753 152.042 507.109 151.21L509.034 146.704C509.85 144.795 512.675 145.24 512.865 147.307L516.62 188.097C516.828 190.361 520.051 190.577 520.561 188.362L523.173 177.011C523.314 176.397 523.737 175.886 524.313 175.631L527.04 174.426C528.107 173.954 529.35 174.492 529.736 175.594L533.882 187.434C534.287 188.593 535.633 189.116 536.715 188.535L538.191 187.743C539.282 187.157 540.638 187.693 541.033 188.867L545.776 202.956C545.865 203.221 546.009 203.464 546.198 203.67L550.514 208.373C551.118 209.03 552.084 209.208 552.883 208.809L556.477 207.011C556.922 206.788 557.268 206.408 557.447 205.944L560.979 196.828C561.632 195.142 564.009 195.119 564.694 196.792L565.642 199.105C566.414 200.988 569.177 200.649 569.472 198.636L574.023 167.532C574.04 167.416 574.067 167.301 574.104 167.19L579.413 151.221C579.578 150.723 579.932 150.311 580.399 150.072L585.176 147.625C585.262 147.581 585.344 147.531 585.423 147.476L588.088 145.582C589.347 144.688 591.101 145.496 591.239 147.034L595.829 198.248C596.008 200.241 598.759 200.618 599.468 198.747V198.747C600.166 196.905 602.865 197.234 603.1 199.19L607.785 238.162C607.807 238.352 607.857 238.538 607.933 238.713L611.354 246.667C612.082 248.359 614.516 248.251 615.091 246.501L619.065 234.409L624.699 210.216L629.376 190.795C629.763 189.186 631.827 188.717 632.871 190.001L633.883 191.245C634.829 192.407 636.669 192.155 637.268 190.782L641.578 180.896L647.213 165.515L651.574 150.605C652.061 148.943 654.286 148.642 655.196 150.116L658.47 155.416L663.986 167.023C664.057 167.171 664.109 167.328 664.141 167.489L669.383 193.676C669.58 194.658 670.472 195.343 671.471 195.28L673.684 195.14C674.648 195.079 675.431 194.337 675.544 193.377L680.972 147.16L685.009 129.76C685.465 127.796 688.212 127.664 688.854 129.576L692.136 139.357C692.198 139.542 692.286 139.717 692.399 139.876L697.863 147.604L700.916 151.713C701.931 153.079 704.081 152.634 704.469 150.976L707.581 137.687C708.035 135.749 710.734 135.592 711.41 137.465L714.743 146.716L718.734 156.417C719.382 157.992 721.578 158.088 722.36 156.574L726 149.535"
                    stroke="#00B4A0"
                  />
                </svg>
              </span>
              <span className={styles.bg_chart}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="300"
                  viewBox="0 0 726 300"
                  fill="none"
                >
                  <path
                    opacity="0.2"
                    d="M0 210.354L5.62281 198.835L11.2569 199.323L16.8798 180.79L22.5139 195.417L28.1368 193.974L33.7709 193.885L39.3937 205.205L45.0278 189.535L50.6506 166.852L56.2734 177.395L61.9075 189.89L67.5305 181.856L73.1646 186.206L78.7874 166.164L84.4215 166.23L90.0443 186.872L95.6784 167.096L101.301 192.043L106.935 182.455L112.558 157.929L118.181 152.247L123.815 142.814L129.438 149.406L135.072 97.4699L140.695 111.12L146.329 126.346L151.952 102.02L157.586 100.888L163.209 107.879L168.832 116.225L174.466 133.825L180.089 116.469L185.723 106.503L191.346 110.387L196.98 126.634L202.602 138.176L208.237 150.183L213.86 165.498L219.494 148.363L225.116 131.717L230.739 113.672L236.373 45.955L241.996 36.2557L247.63 53.1684L253.253 33.2594L258.887 87.7262L264.51 95.0728L270.144 110.898L275.767 113.495L281.39 85.5289L287.024 70.7913L292.647 68.816L298.281 75.7408L303.904 77.4942L309.538 81.7557L315.161 71.9455L320.795 70.0145L326.418 57.7184L332.052 87.2379L337.675 98.1579L343.298 99.3564L348.932 83.8864L354.555 69.4152L360.189 61.536L365.811 51.0599L371.446 65.6642L377.068 35.6343L382.702 6.40327L388.325 11.0642L393.948 1.34279L399.582 25.9794L405.205 22.406L410.839 0.854492L416.462 17.6562L422.096 16.0804L427.719 13.5723L433.353 21.496L438.976 21.4294L444.61 30.9289L450.233 34.0584L455.856 64.4213L461.49 97.2479L467.113 90.7669L472.747 142.726L478.37 132.716L484.004 107.236L489.627 104.972L495.261 152.025L500.884 155.821L506.506 156.62L512.14 143.436L517.763 204.517L523.398 180.036L529.02 177.55L534.654 193.641L540.277 190.623L545.911 207.358L551.534 213.484L557.168 210.665L562.791 196.149L568.414 209.866L574.048 171.357L579.671 154.445L585.305 151.559L590.928 147.564L596.562 210.421L602.185 195.572L607.819 242.448L613.442 255.521L619.065 238.409L624.699 214.216L630.322 190.867L635.956 197.792L641.578 184.896L647.213 169.515L652.835 150.294L658.47 159.416L664.092 171.246L669.726 199.39L675.349 199.035L680.972 151.16L686.606 126.878L692.229 143.636L697.863 151.604L703.486 159.172L709.12 135.113L714.743 150.716L720.377 164.41L726 153.535V300H0V210.354Z"
                    fill="url(#paint0_linear_263_12054)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_263_12054"
                      x1="363"
                      y1="0.854492"
                      x2="363"
                      y2="300"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#00B4A0" stopOpacity="0.3" stop />
                      <stop offset="1" stopColor="#00B4A0" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <div className={styles.top_block}>
                <div className={styles.balance_profit}>
                  <div className={styles.balance}>
                    <label>{t('Available Balance:')}</label>
                    <h2>{parseFloat(account?.AccountBalance).toFixed(1)}</h2>
                  </div>
                  <div className={styles.profit}>
                    <label>{t('Current Profit:')}</label>
                    <p>
                      {currentProfit} ({profitPercentage ? profitPercentage : 0}
                      %)
                    </p>
                  </div>
                </div>
                <div className={styles.tabs}></div>
              </div>
              <div className={styles.currency}>
                <label>{t("Currency")}:</label>
                <span>
                  {account?.AccountCurrency === "USD" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"3.2vh"}
                      height={"3.2vh"}
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M15.7573 31.0405C24.1025 31.0405 30.8161 24.3268 30.8161 15.9817C30.8161 7.63653 24.1025 0.922852 15.7573 0.922852C7.41216 0.922852 0.698486 7.63653 0.698486 15.9817C0.698486 24.3268 7.41216 31.0405 15.7573 31.0405Z"
                        fill="#00B4A0"
                      />
                      <path
                        d="M19.8986 18.3659C19.8986 16.1699 18.581 15.4169 15.9458 15.1033C14.0634 14.8522 13.687 14.3503 13.687 13.4718C13.687 12.5932 14.3145 12.0287 15.5693 12.0287C16.6987 12.0287 17.3262 12.4052 17.6399 13.3463C17.7026 13.5346 17.8909 13.66 18.0791 13.66H19.0829C19.3339 13.66 19.5222 13.4718 19.5222 13.2209V13.1581C19.2712 11.7776 18.1418 10.711 16.6987 10.5856V9.0797C16.6987 8.82867 16.5105 8.64043 16.1968 8.57764H15.2556C15.0046 8.57764 14.8164 8.76587 14.7536 9.0797V10.5228C12.8712 10.7738 11.6792 12.0287 11.6792 13.5974C11.6792 15.668 12.934 16.4836 15.5693 16.7974C17.3262 17.1111 17.8909 17.4875 17.8909 18.4915C17.8909 19.4955 17.0124 20.1856 15.8203 20.1856C14.1889 20.1856 13.6242 19.4953 13.4359 18.5541C13.3733 18.3033 13.1851 18.1777 12.9968 18.1777H11.9301C11.6792 18.1777 11.491 18.3659 11.491 18.6169V18.6797C11.7418 20.2483 12.7458 21.3777 14.8164 21.6915V23.1974C14.8164 23.4483 15.0046 23.6365 15.3183 23.6993H16.2594C16.5105 23.6993 16.6987 23.5111 16.7615 23.1974V21.6915C18.6438 21.3777 19.8986 20.06 19.8986 18.3659Z"
                        fill="white"
                      />
                      <path
                        d="M12.5588 24.9541C7.66472 23.1973 5.15486 17.7385 6.97457 12.907C7.91575 10.2717 9.98634 8.26391 12.5588 7.32273C12.8099 7.19729 12.9353 7.00906 12.9353 6.69523V5.81685C12.9353 5.56582 12.8099 5.37759 12.5588 5.31494C12.496 5.31494 12.3706 5.31494 12.3078 5.37759C6.34707 7.25994 3.08427 13.5973 4.96663 19.558C6.09604 23.0717 8.79413 25.7698 12.3078 26.8992C12.5588 27.0246 12.8099 26.8992 12.8725 26.6482C12.9353 26.5855 12.9353 26.5227 12.9353 26.3973V25.5188C12.9353 25.3305 12.7471 25.0796 12.5588 24.9541ZM19.2099 5.37759C18.9588 5.25215 18.7078 5.37759 18.6452 5.62862C18.5824 5.69141 18.5824 5.75406 18.5824 5.87965V6.75803C18.5824 7.00906 18.7706 7.25994 18.9588 7.38553C23.853 9.14229 26.3628 14.6011 24.5431 19.4326C23.6019 22.0679 21.5313 24.0757 18.9588 25.0169C18.7078 25.1423 18.5824 25.3305 18.5824 25.6444V26.5227C18.5824 26.7738 18.7078 26.962 18.9588 27.0246C19.0216 27.0246 19.1471 27.0246 19.2099 26.962C25.1706 25.0796 28.4334 18.7423 26.551 12.7816C25.4216 9.20509 22.6607 6.507 19.2099 5.37759Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      viewBox="0 0 32 32"
                      width={"3.2vh"}
                      height={"3.2vh"}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#000000"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <g fill="none" fill-rule="evenodd">
                          {" "}
                          <circle
                            cx="16"
                            cy="16"
                            fill="#0f8ff8"
                            r="16"
                          ></circle>{" "}
                          <path
                            d="M8 19.004L8.81 17h.857a16.279 16.279 0 01-.034-1.03c0-.448.019-.864.056-1.25H8l.81-2.003h1.274C11.27 8.906 13.944 7 18.103 7c1.367 0 2.666.177 3.897.532v2.524a8.92 8.92 0 00-3.683-.776c-2.493 0-4.096 1.146-4.81 3.438h7.423l-.81 2.003h-7.097a6.938 6.938 0 00-.056.995c0 .479.015.907.045 1.285h6.183l-.8 2.003H13.44c.533 1.389 1.183 2.355 1.949 2.9.765.544 1.858.816 3.277.816 1.014 0 2.125-.247 3.334-.741v2.373c-1.149.432-2.515.648-4.1.648-4.167 0-6.803-1.999-7.906-5.996z"
                            fill="#ffffff"
                          ></path>{" "}
                        </g>{" "}
                      </g>
                    </svg>
                  )}
                  {account?.AccountCurrency}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.account_blocks}>
            <div className={styles.account_block}>
              <div className={styles.top}>
                <div className={styles.title_button}>
                  <p>{t("Deposit")}</p>
                  <Link to={`/cabinet/deposit/${account?.Id}`}>
                    {t("Deposit")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12.6668 13.333V9.33301M12.6668 9.33301L14.0002 10.6663M12.6668 9.33301L11.3335 10.6663"
                        stroke="#00B4A0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.6668 8.00033C14.6668 5.48617 14.6668 4.22909 13.8858 3.44804C13.1047 2.66699 11.8477 2.66699 9.3335 2.66699H6.66683C4.15267 2.66699 2.89559 2.66699 2.11454 3.44804C1.3335 4.22909 1.3335 5.48617 1.3335 8.00033C1.3335 10.5145 1.3335 11.7716 2.11454 12.5526C2.89559 13.3337 4.15267 13.3337 6.66683 13.3337H9.3335"
                        stroke="#00B4A0"
                        strokeLinecap="round"
                      />
                      <path
                        d="M6.66667 10.667H4"
                        stroke="#00B4A0"
                        strokeLinecap="round"
                      />
                      <path
                        d="M8.66683 10.667H8.3335"
                        stroke="#00B4A0"
                        strokeLinecap="round"
                      />
                      <path
                        d="M1.3335 6.66699L14.6668 6.66699"
                        stroke="#00B4A0"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Link>
                </div>
                <div className={styles.amount}>
                {getSymbolByAccount()}{' '}
                  {deposit
                    ? parseFloat(
                        deposit *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)
                    : 0}
                </div>
              </div>
              <Link
                to={`/cabinet/deposit/${account?.Id}`}
                className={styles.mobile_button}
              >
                {t("Deposit")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.6vh"}
                  height={"1.6vh"}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.6668 13.333V9.33301M12.6668 9.33301L14.0002 10.6663M12.6668 9.33301L11.3335 10.6663"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.6668 8.00033C14.6668 5.48617 14.6668 4.22909 13.8858 3.44804C13.1047 2.66699 11.8477 2.66699 9.3335 2.66699H6.66683C4.15267 2.66699 2.89559 2.66699 2.11454 3.44804C1.3335 4.22909 1.3335 5.48617 1.3335 8.00033C1.3335 10.5145 1.3335 11.7716 2.11454 12.5526C2.89559 13.3337 4.15267 13.3337 6.66683 13.3337H9.3335"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6.66667 10.667H4"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.66683 10.667H8.3335"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1.3335 6.66699L14.6668 6.66699"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                </svg>
              </Link>

              <div className={styles.select}></div>
            </div>
            <div className={styles.account_block}>
              <div className={styles.top}>
                <div className={styles.title_button}>
                  <p>{t("Withdrawal")}</p>
                  <Link to={`/cabinet/withdrawal/${account?.Id}`}>
                    {t("Withdrawal")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 17 16"
                      fill="none"
                    >
                      <path
                        d="M13.1668 9.33301V13.333M13.1668 13.333L14.5002 11.9997M13.1668 13.333L11.8335 11.9997"
                        stroke="#E9770E"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.1668 8.00033C15.1668 5.48617 15.1668 4.22909 14.3858 3.44804C13.6047 2.66699 12.3477 2.66699 9.8335 2.66699H7.16683C4.65267 2.66699 3.39559 2.66699 2.61454 3.44804C1.8335 4.22909 1.8335 5.48617 1.8335 8.00033C1.8335 10.5145 1.8335 11.7716 2.61454 12.5526C3.39559 13.3337 4.65267 13.3337 7.16683 13.3337H9.8335"
                        stroke="#E9770E"
                        strokeLinecap="round"
                      />
                      <path
                        d="M7.16667 10.667H4.5"
                        stroke="#E9770E"
                        strokeLinecap="round"
                      />
                      <path
                        d="M9.16683 10.667H8.8335"
                        stroke="#E9770E"
                        strokeLinecap="round"
                      />
                      <path
                        d="M1.8335 6.66699L15.1668 6.66699"
                        stroke="#E9770E"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Link>
                </div>
                <div className={styles.amount}>
                {getSymbolByAccount()}{' '}
                  {withdrawal
                    ? parseFloat(
                        withdrawal *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)
                    : 0}
                </div>
              </div>
              <Link
                className={styles.mobile_button}
                to={`/cabinet/withdrawal/${account?.Id}`}
              >
                {t("Withdrawal")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.6vh"}
                  height={"1.6vh"}
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.1668 9.33301V13.333M13.1668 13.333L14.5002 11.9997M13.1668 13.333L11.8335 11.9997"
                    stroke="#E9770E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.1668 8.00033C15.1668 5.48617 15.1668 4.22909 14.3858 3.44804C13.6047 2.66699 12.3477 2.66699 9.8335 2.66699H7.16683C4.65267 2.66699 3.39559 2.66699 2.61454 3.44804C1.8335 4.22909 1.8335 5.48617 1.8335 8.00033C1.8335 10.5145 1.8335 11.7716 2.61454 12.5526C3.39559 13.3337 4.65267 13.3337 7.16683 13.3337H9.8335"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.16667 10.667H4.5"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.16683 10.667H8.8335"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1.8335 6.66699L15.1668 6.66699"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                </svg>
              </Link>
              <div className={styles.select}></div>
            </div>
            {/* <div className={styles.account_block}>
                            <div className={styles.top}>
                            <div className={styles.title_button}>
                                    <p>Transfer</p>
                                    <button>
                                        {t('Transfer')}
                                        <svg xmlns="http://www.w3.org/2000/svg" width={"1.6vh"} height={"1.6vh"} viewBox="0 0 16 16" fill="none">
                                            <path d="M8.05276 1.5C4.8571 1.5 2.23001 3.942 1.97386 7.05556H1.33351C1.13092 7.05556 0.948356 7.1778 0.871196 7.36512C0.794037 7.55244 0.837536 7.76781 0.981349 7.9105L2.10122 9.02161C2.29616 9.21502 2.61061 9.21502 2.80555 9.02161L3.92542 7.9105C4.06923 7.76781 4.11273 7.55244 4.03557 7.36512C3.95841 7.1778 3.77585 7.05556 3.57326 7.05556H2.97803C3.23117 4.50111 5.40336 2.5 8.05276 2.5C9.89911 2.5 11.5153 3.4723 12.4106 4.92853C12.5552 5.16377 12.8631 5.23723 13.0984 5.09261C13.3336 4.94799 13.4071 4.64005 13.2624 4.40481C12.1915 2.66285 10.2584 1.5 8.05276 1.5Z" fill="#52A5E5"/>
                                            <path d="M13.8943 6.97772C13.6995 6.7852 13.3861 6.7852 13.1913 6.97772L12.0671 8.08883C11.9229 8.23137 11.8791 8.44688 11.9561 8.63444C12.0332 8.82199 12.2159 8.94444 12.4186 8.94444H13.018C12.7639 11.4975 10.5841 13.5 7.922 13.5C6.067 13.5 4.44407 12.5269 3.54547 11.0707C3.40045 10.8358 3.09238 10.7628 2.85738 10.9078C2.62239 11.0529 2.54945 11.3609 2.69447 11.5959C3.76954 13.338 5.70953 14.5 7.922 14.5C11.1273 14.5 13.7651 12.0595 14.0222 8.94444H14.6669C14.8697 8.94444 15.0524 8.82199 15.1294 8.63444C15.2065 8.44688 15.1626 8.23137 15.0184 8.08883L13.8943 6.97772Z" fill="#52A5E5"/>
                                        </svg>
                                    </button>
                                </div>
                                <div className={styles.amount}>
                                    $12491
                                </div>
                            </div>
                            <div className={styles.select}>

                            </div>
                        </div> */}
          </div>
        </div>
        <div className={styles.transactions}>
          <div className={styles.transaction_header}>
            <h3>{t("Transactions")}</h3>
            <div className={styles.tabs}></div>
          </div>
          <Table data={transactions} columns={columns} theme={theme} />
        </div>

        <div className={styles.mobile_transactions}>
          <div className={styles.label}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"16px"}
              height={"16px"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M6.66659 2.66699H9.33325C11.8474 2.66699 13.1045 2.66699 13.8855 3.44804C14.4479 4.0104 14.6054 4.81954 14.6494 6.16699H1.3504C1.39448 4.81954 1.55194 4.0104 2.1143 3.44804C2.89535 2.66699 4.15243 2.66699 6.66659 2.66699Z"
                fill="#FCFCFC"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.6663 8.54534L14.3939 8.273C13.8081 7.68721 12.8584 7.68721 12.2726 8.273L11.7383 8.80729C11.5251 8.23851 10.9765 7.83366 10.3333 7.83366C9.50483 7.83366 8.83325 8.50523 8.83325 9.33366V10.5096C8.50665 10.5459 8.18969 10.6892 7.93926 10.9397C7.35347 11.5255 7.35347 12.4752 7.93926 13.061L8.21193 13.3337H6.66659C4.15243 13.3337 2.89535 13.3337 2.1143 12.5526C1.33325 11.7716 1.33325 10.5145 1.33325 8.00033C1.33325 7.7057 1.33325 7.42835 1.33451 7.16699H14.6653C14.6666 7.42835 14.6666 7.7057 14.6666 8.00033C14.6666 8.18896 14.6666 8.37053 14.6663 8.54534ZM3.99992 10.167C3.72378 10.167 3.49992 10.3908 3.49992 10.667C3.49992 10.9431 3.72378 11.167 3.99992 11.167H6.66659C6.94273 11.167 7.16659 10.9431 7.16659 10.667C7.16659 10.3908 6.94273 10.167 6.66659 10.167H3.99992Z"
                fill="#FCFCFC"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3333 8.83366C10.6094 8.83366 10.8333 9.05752 10.8333 9.33366V12.1266L11.313 11.6468C11.5083 11.4515 11.8249 11.4515 12.0201 11.6468C12.2154 11.842 12.2154 12.1586 12.0201 12.3539L10.6868 13.6872C10.4915 13.8825 10.175 13.8825 9.9797 13.6872L8.64637 12.3539C8.4511 12.1586 8.4511 11.842 8.64637 11.6468C8.84163 11.4515 9.15821 11.4515 9.35347 11.6468L9.83325 12.1266V9.33366C9.83325 9.05752 10.0571 8.83366 10.3333 8.83366ZM12.9797 8.98011C13.175 8.78484 13.4915 8.78484 13.6868 8.98011L15.0201 10.3134C15.2154 10.5087 15.2154 10.8253 15.0201 11.0205C14.8249 11.2158 14.5083 11.2158 14.313 11.0205L13.8333 10.5408V13.3337C13.8333 13.6098 13.6094 13.8337 13.3333 13.8337C13.0571 13.8337 12.8333 13.6098 12.8333 13.3337V10.5408L12.3535 11.0205C12.1582 11.2158 11.8416 11.2158 11.6464 11.0205C11.4511 10.8253 11.4511 10.5087 11.6464 10.3134L12.9797 8.98011Z"
                fill="#FCFCFC"
              />
            </svg>
            {t("Transactions")}
          </div>
          <div className={styles.transactions_list}>
            {transactions.map((el) => (
              <div className={styles.transaction} key={el.Id}>
                <div className={styles.type_status}>
                  <div
                    className={`${styles.type} ${
                      el.Type === "Withdrawal" ? styles.with : ""
                    }`}
                  >
                    {el.Type === "Withdrawal" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <path
                          d="M13.3812 9.33301V13.333M13.3812 13.333L14.7145 11.9997M13.3812 13.333L12.0479 11.9997"
                          stroke="#E9770E"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.3809 8.00033C15.3809 5.48617 15.3809 4.22909 14.5999 3.44804C13.8188 2.66699 12.5618 2.66699 10.0476 2.66699H7.38094C4.86678 2.66699 3.6097 2.66699 2.82866 3.44804C2.04761 4.22909 2.04761 5.48617 2.04761 8.00033C2.04761 10.5145 2.04761 11.7716 2.82866 12.5526C3.6097 13.3337 4.86678 13.3337 7.38094 13.3337H10.0476"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M7.38102 10.667H4.71436"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.38119 10.667H9.04785"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2.04761 6.66699L15.3809 6.66699"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <path
                          d="M13.3812 13.333V9.33301M13.3812 9.33301L14.7145 10.6663M13.3812 9.33301L12.0479 10.6663"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.3809 8.00033C15.3809 5.48617 15.3809 4.22909 14.5999 3.44804C13.8188 2.66699 12.5618 2.66699 10.0476 2.66699H7.38094C4.86678 2.66699 3.6097 2.66699 2.82866 3.44804C2.04761 4.22909 2.04761 5.48617 2.04761 8.00033C2.04761 10.5145 2.04761 11.7716 2.82866 12.5526C3.6097 13.3337 4.86678 13.3337 7.38094 13.3337H10.0476"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M7.38102 10.667H4.71436"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.38119 10.667H9.04785"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2.04761 6.66699L15.3809 6.66699"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                      </svg>
                    )}
                    {el.Type}
                  </div>
                  <div className={styles.status}>{t("Completed")}</div>
                </div>
                <div className={styles.account_amount}>
                  <div className={styles.account}>
                    <label htmlFor="">{t("Account")}</label>
                    <p>{account?.Id}</p>
                  </div>
                  <div className={styles.amount}>
                    <label htmlFor="">{t("Amount")}</label>
                    <p
                      className={`${
                        el.Type === "Withdrawal" ? styles.with : ""
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_575_44989)">
                          <path
                            d="M7.87878 15.5202C12.0514 15.5202 15.4082 12.1634 15.4082 7.99084C15.4082 3.81826 12.0514 0.461426 7.87878 0.461426C3.7062 0.461426 0.349365 3.81826 0.349365 7.99084C0.349365 12.1634 3.7062 15.5202 7.87878 15.5202Z"
                            fill="#00B4A0"
                          />
                          <path
                            d="M9.9492 9.18271C9.9492 8.08469 9.29039 7.70822 7.97276 7.55138C7.03159 7.42587 6.84336 7.17491 6.84336 6.73564C6.84336 6.29638 7.15711 6.0141 7.78452 6.0141C8.34922 6.0141 8.66297 6.20233 8.8198 6.67292C8.8512 6.76704 8.94532 6.82976 9.03943 6.82976H9.54134C9.66685 6.82976 9.76097 6.73564 9.76097 6.6102V6.5788C9.63545 5.88858 9.07076 5.35527 8.34922 5.29255V4.53961C8.34922 4.41409 8.25511 4.31997 8.09827 4.28857H7.62769C7.50217 4.28857 7.40806 4.38269 7.37666 4.53961V5.26115C6.4355 5.38667 5.83948 6.0141 5.83948 6.79844C5.83948 7.83374 6.4669 8.24153 7.78452 8.39844C8.66297 8.55528 8.94532 8.74352 8.94532 9.24551C8.94532 9.74749 8.50606 10.0926 7.91004 10.0926C7.09431 10.0926 6.81196 9.74742 6.71785 9.27683C6.68653 9.15139 6.59241 9.08859 6.49829 9.08859H5.96492C5.83948 9.08859 5.74536 9.18271 5.74536 9.30823V9.33962C5.8708 10.1239 6.37278 10.6886 7.40806 10.8455V11.5985C7.40806 11.7239 7.50218 11.818 7.65901 11.8494H8.12959C8.25511 11.8494 8.34922 11.7553 8.38062 11.5985V10.8455C9.32178 10.6886 9.9492 10.0298 9.9492 9.18271Z"
                            fill="white"
                          />
                          <path
                            d="M6.27942 12.4773C3.83236 11.5989 2.57743 8.86948 3.48729 6.45374C3.95787 5.1361 4.99317 4.1322 6.27942 3.66161C6.40493 3.59889 6.46765 3.50477 6.46765 3.34786V2.90867C6.46765 2.78315 6.40493 2.68904 6.27942 2.65771C6.24802 2.65771 6.1853 2.65771 6.1539 2.68904C3.17354 3.63021 1.54214 6.79889 2.48331 9.77926C3.04802 11.5361 4.39706 12.8851 6.1539 13.4498C6.27942 13.5126 6.40493 13.4498 6.43626 13.3243C6.46765 13.293 6.46765 13.2616 6.46765 13.1989V12.7596C6.46765 12.6655 6.37354 12.5401 6.27942 12.4773ZM9.60493 2.68904C9.47942 2.62632 9.3539 2.68904 9.32258 2.81455C9.29118 2.84595 9.29118 2.87727 9.29118 2.94007V3.37926C9.29118 3.50477 9.3853 3.63021 9.47942 3.69301C11.9265 4.57139 13.1814 7.3008 12.2715 9.71654C11.801 11.0342 10.7657 12.0381 9.47942 12.5087C9.3539 12.5714 9.29118 12.6655 9.29118 12.8224V13.2616C9.29118 13.3871 9.3539 13.4812 9.47942 13.5126C9.51082 13.5126 9.57354 13.5126 9.60493 13.4812C12.5853 12.5401 14.2167 9.37139 13.2755 6.39102C12.7108 4.60279 11.3304 3.25374 9.60493 2.68904Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_575_44989">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {el.Type === "Withdrawal" ? "-" : "+"}
                      {getSymbolByAccount()}
                      {parseFloat(
                        el.Sum *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)}
                    </p>
                  </div>
                </div>
                <div className={styles.id_date}>
                  <div className={styles.id}>ID {el.Id}</div>
                  {/* <div className={styles.date}>
                    {moment(el.Date).format("YYYY-MM-DD HH:mm")}
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
